import * as React from 'react';
import { useSelector } from 'react-redux';

import { useBSCParkingsSelector } from '../../hooks/selectors/useBSCParkingsSelector';
import { useIsMultiAdsSelector } from '../../hooks/selectors/useIsMultiAdsSelector';
import { useOfferSelector } from '../../hooks/selectors/useOfferSelector';
import { getIsNewMultiAddsEnabled } from '../../selectors/featureToggle';
import * as styles from './ObjectSummaryDescription.css';
import { descriptionConfig } from './internal/config';
import { useObjectSummaryTitleSelector } from './internal/hooks/useObjectSummaryTitleSelector';
import { enrichConfigForMultiAds } from './internal/utils/enrichConfigForMultiAds';
import { getExtendedCategory } from './internal/utils/getExtendedCategory';
import { getFormattedConfig } from './internal/utils/getFormattedConfig';

export const ObjectSummaryDescription: React.VFC = () => {
  /**
   * @todo Удалить строку с RS
   * @description Данный функционал появился в задаче CD-150860, будет удалён в задаче CD-151061
   */
  const isNewMultiAddsEnabled = useSelector(getIsNewMultiAddsEnabled);

  const isOfferMultiAds = useIsMultiAdsSelector();
  const bscParkings = useBSCParkingsSelector();

  /**
   * @todo Удалить "isNewMultiAddsEnabled", когда будет удален фича-тогл
   * @description Данный функционал появился в задаче CD-150860, будет удалён в задаче CD-151061
   */
  const isCommercialMultiAds = isNewMultiAddsEnabled && isOfferMultiAds;

  const offer = useOfferSelector();

  const title = useObjectSummaryTitleSelector();

  const descriptionProps = offer.areaParts?.length ? { id: '/area-parts' } : null;

  const extendedCategory = getExtendedCategory(offer);

  const offerConfig = descriptionConfig[extendedCategory] ?? [];
  const offerConfigWithMultiAds = enrichConfigForMultiAds(offerConfig, isCommercialMultiAds);

  return (
    <div className={styles['container']}>
      {!!title && (
        <div data-testid="object-summary-description-title" className={styles['title_block']}>
          {title}
        </div>
      )}

      <div
        data-testid="object-summary-description-info-block"
        itemScope
        className={styles['info-block']}
        {...descriptionProps}
      >
        {offerConfigWithMultiAds.reduce<Array<JSX.Element>>((accumulator, config) => {
          const [title, value] = getFormattedConfig(config, offer, { isCommercialMultiAds, bscParkings }) || [];

          if (value) {
            accumulator.push(
              <div data-testid="object-summary-description-info" className={styles['info']} key={`${title}_${value}`}>
                <div data-testid="object-summary-description-value" className={styles['info-value']}>
                  {value}
                </div>
                <div data-testid="object-summary-description-title" className={styles['info-title']}>
                  {title}
                </div>
              </div>,
            );
          }

          return accumulator;
        }, Array.of<JSX.Element>())}
      </div>
    </div>
  );
};

ObjectSummaryDescription.displayName = 'ObjectSummaryDescription';
